import { Helmet } from "react-helmet-async"
import { ISupplier, SupplierBasicDetails } from "../../../../Supplier"
import { useOutletContext } from "react-router"

export default function Supplier() {
	const { transportServiceProvider, revalidate } = useOutletContext<{
		transportServiceProvider: ISupplier
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Supplier Details</title>
			</Helmet>
			<SupplierBasicDetails
				supplier={transportServiceProvider}
				revalidate={revalidate}
			/>
		</>
	)
}
